import { render } from "./HeatMap.vue?vue&type=template&id=067fe236&scoped=true&lang=pug"
import script from "./HeatMap.vue?vue&type=script&lang=js"
export * from "./HeatMap.vue?vue&type=script&lang=js"

import "./HeatMap.vue?vue&type=style&index=0&id=067fe236&lang=scss&scoped=true"
import "./HeatMap.vue?vue&type=style&index=1&id=067fe236&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067fe236"]])

export default __exports__